import Figures from './components/Figures';
import Files from './components/Files';
import Manuscripts from './components/Manuscripts';
import Tables from './components/Tables';
import FileWithPopoverErrorStatus from './components/FileWithPopoverErrorStatus';
import { FILE_STATUS } from './constants';
export var endpoints = {
  admin: '/api/admin/file',
  researcher: '/api/file'
};
export var Components = {
  Figures: Figures,
  Files: Files,
  Manuscripts: Manuscripts,
  Tables: Tables,
  FileWithPopoverErrorStatus: FileWithPopoverErrorStatus
};
export var CONSTANTS = FILE_STATUS;
export default Files;